import createQueryParamsForGetReq from 'helper/createQueryParamsForGetReq';
import { useQuery } from 'react-query';
import apiEndPoints from 'services/apiEndPoints';
import makeApiRequest from 'services/makeApiRequest';
export default function useSearchMails({ search }) {
  return useQuery(
    ['get-mails', search],
    async () => {
      const response = await makeApiRequest.get(
        createQueryParamsForGetReq(apiEndPoints.SEARCH_MAILS, {
          search: search,
        })
      );
      return response?.data;
    },
    { enabled: !!search }
  );
}
